import React from "react";
import styled from "styled-components";
import { DividerProps } from "@xsolla/xui-primitives-core";
import { createFilteredElement } from "./filterDOMProps";

const FilteredDiv = createFilteredElement("div");

const StyledDivider = styled(FilteredDiv)<DividerProps>`
  background-color: ${(props) =>
    props.dashStroke
      ? "transparent"
      : props.color || "rgba(255, 255, 255, 0.15)"};
  width: ${(props) =>
    props.vertical
      ? typeof props.width === "number"
        ? `${props.width}px`
        : props.width || "1px"
      : "100%"};
  height: ${(props) =>
    props.vertical
      ? "100%"
      : typeof props.height === "number"
        ? `${props.height}px`
        : props.height || "1px"};

  ${(props) =>
    props.dashStroke &&
    `
    border-style: dashed;
    border-color: ${props.color || "rgba(255, 255, 255, 0.15)"};
    border-width: 0;
    ${
      props.vertical
        ? `
      border-left-width: ${typeof props.width === "number" ? `${props.width}px` : props.width || "1px"};
      height: 100%;
    `
        : `
      border-top-width: ${typeof props.height === "number" ? `${props.height}px` : props.height || "1px"};
      width: 100%;
    `
    }
  `}
`;

export const Divider: React.FC<DividerProps> = ({
  testID,
  "data-testid": dataTestId,
  ...props
}) => {
  return <StyledDivider data-testid={dataTestId || testID} {...props} />;
};
